















































































import {
  CommerceKindParams
} from '@/store/interfaces/commerceKind';
import commerceKind from '@/store/types/commerceKind';
import editModal from '@/components/CommerceKind/edit.vue';
import newCommerceKindModal from '@/components/CommerceKind/new.vue';
import deleteCommerceKind from '@/components/modals/actionConfirm.vue';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({

  name: 'CommerceKindList',
  components: {
    editModal,
    newCommerceKindModal,
    deleteCommerceKind,
  },
  data: () => ({
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'name',
        label: 'Categoría',
        minWidth: 275,
        sortable: true,
      },
      {
        prop: 'commerces_count',
        label: '', // assigned in created function
        minWidth: 200,
        formatter: (row: CommerceKindParams) => {
          return `${row.commerces_count == null ? 0 : row.commerces_count}`;
        },
      },
      {
        prop: 'icon_url',
        label: 'Icono',
        slotName: 'icon',
        minWidth: 40,
      }
    ] as tTableColumns,
    editModal: false,
    newCommerceKind: false,
    currentCommerceKind: {},
    confirmDeleteCommerceKind: false,
  }),
  computed: {
    ...mapGetters({
      getCommerceKindList: `commerceModule/commerceKind/${commerceKind.getters.GET_COMMERCE_KIND}`,
    }),
  },
  methods: {
    ...mapActions({
      CommerceKindList: `commerceModule/commerceKind/${commerceKind.actions.LIST_COMMERCE_KIND}`,
      deleteCommerceKindList: `commerceModule/commerceKind/${commerceKind.actions.DELETE_COMMERCE_KIND}`,
    }),
    rowSelect(row: CommerceKindParams): void{
      this.$data.currentCommerceKind = row;
    },
    edit(): void {
      this.$data.editModal = true;
    },
    saveCommerceKind(): void{
      this.$data.newCommerceKind = true;
    },
    confirmDeletion(): void{
      this.deleteCommerceKindList(this.$data.currentCommerceKind.id).then(() => {
        this.$data.confirmDeleteCommerceKind = false;
      });
    },
    remove(): void {
      this.$data.confirmDeleteCommerceKind = true;
    },
  },
  created() {
    this.$data.tableColumns[1].label = `${this.$t('menu.commerce.plural.formal')} por categoría`;
  },
});
